export const JOB_CATEGORIES = [
  '司机', 'CLASS A 司机', 'CLASS B 司机', 'CLASS D 司机', '调度找召卡车',
  '文员OP', '跟单/客服', '应收应付会计', '卸柜搬货工',
  '出单出货 点数', '物流销售', '货运代理', '卡车修理技工', '货运经纪', '报关师'
];

export const LOCATIONS = [
  'Alabama (AL)', 'Alaska (AK)', 'Arizona (AZ)', 'Arkansas (AR)', 'California (CA)',
  'Colorado (CO)', 'Connecticut (CT)', 'Delaware (DE)', 'Florida (FL)', 'Georgia (GA)',
  'Hawaii (HI)', 'Idaho (ID)', 'Illinois (IL)', 'Indiana (IN)', 'Iowa (IA)',
  'Kansas (KS)', 'Kentucky (KY)', 'Louisiana (LA)', 'Maine (ME)', 'Maryland (MD)',
  'Massachusetts (MA)', 'Michigan (MI)', 'Minnesota (MN)', 'Mississippi (MS)', 'Missouri (MO)',
  'Montana (MT)', 'Nebraska (NE)', 'Nevada (NV)', 'New Hampshire (NH)', 'New Jersey (NJ)',
  'New Mexico (NM)', 'New York (NY)', 'North Carolina (NC)', 'North Dakota (ND)', 'Ohio (OH)',
  'Oklahoma (OK)', 'Oregon (OR)', 'Pennsylvania (PA)', 'Rhode Island (RI)', 'South Carolina (SC)',
  'South Dakota (SD)', 'Tennessee (TN)', 'Texas (TX)', 'Utah (UT)', 'Vermont (VT)',
  'Virginia (VA)', 'Washington (WA)', 'West Virginia (WV)', 'Wisconsin (WI)', 'Wyoming (WY)',
  'Washington D.C.'
];

export const WORK_TYPES = ['全职', '兼职', '合同工', '临时工'];
export const EXPERIENCE_OPTIONS = ['经验不限', '1年以内', '一年以上', '1-3年', '3-5年', '5-10年', '10年以上'];
